<div class="modal-header">
  <h5 class="modal-title">Update user</h5>
  <button type="button" class="btn btn-link close pull-right" aria-label="Close" (click)="close()">
    <i class="fa fa-lg fa-times"></i>
  </button>
</div>
<div class="modal-body">

  <form [formGroup]="userForm">

    <div class="row">
      <div class="col-24 ps-2 pb-2">
        <label>Email</label>
        <input type="text" class="form-control" formControlName="email">
      </div>
    </div>

    <div class="row">
      <div class="col-24 ps-2 pb-2" formGroupName="roles">
        <label>Roles</label>
        <fxch-accordion #accordionComponent class="mb-2" [collapsing]="collapsing">
          <accordion-item #item
                          [title]="a.name"
                          *ngFor="let a of applications; let i = index;"
                          [disabled]="!applicationAccessesState[a.id]" [disableClose]="applicationAccessesState[a.id] && (userForm.value.roles[a.id] === null || userForm.value.roles[a.id] === undefined)">
            <ng-template accordionHeaderContent>
              <input class="form-check-input form-check-input-larger" type="checkbox" [(ngModel)]="applicationAccessesState[a.id]" [ngModelOptions]="{standalone: true}" (ngModelChange)="toggleApplication($event, i, a.id)">
            </ng-template>
            <ng-template accordionContent>
              <ng-select formControlName="{{a.id}}" [searchable]="false" [items]="applicationsJson[a.id].roles" [clearable]="false" [bindLabel]="'name'" [bindValue]="'name'"></ng-select>
            </ng-template>
          </accordion-item>
        </fxch-accordion>
      </div>
    </div>

  </form>

</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="update()" [disabled]="userForm.invalid || !isSubmitEnabled">
    <i class="fa fa-lg fa-plus-circle"></i>
    Submit
  </button>

  <button class="btn btn-outline-primary" (click)="close()">
    Close
  </button>
</div>
